export default __webpack_public_path__ + "static/media/aakash_new.d420cebf.JPG";